import { Button, Loading } from '@autopass-web/mochi-component';

import { environment } from '../environments/environment';
import { useEnhancedNavigate } from '../routes/navigate';
import { useParkingLotInfo } from '../routes/parking-lot';
import { PATHS } from '../routes/routes';

export function EntryPage() {
  const navigate = useEnhancedNavigate();
  const { parkingLotInfo, isValidParkingLot, isPending } = useParkingLotInfo();

  if (isPending && isValidParkingLot) {
    return (
      <div className="flex flex-col w-full h-screen">
        <Loading />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full h-screen">
      <div
        className="basis-3/4"
        style={{
          background: 'url("../assets/img-entry-car.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {parkingLotInfo?.name && (
          <div className="text-center text-2xl mt-8">{parkingLotInfo.name}</div>
        )}
        <div className="text-center text-3xl mt-8 font-medium">
          繳費免排隊
          <br />
          取車出場自動扣
        </div>
      </div>
      <div
        className="basis-1/4"
        style={{
          backgroundColor: '#DDE9ED',
        }}
      >
        <div className="flex flex-col items-center justify-center mx-4 h-full">
          <div className="text-gray-400">
            <span>開始使用即同意</span>
            <a href={environment.termsUrl} style={{ color: '#007aff' }}>
              服務條款
            </a>
            &nbsp;/&nbsp;
            <a href={environment.privacyUrl} style={{ color: '#007aff' }}>
              隱私權政策
            </a>
            &nbsp;/&nbsp;
            <a
              href={environment.payTaipeiPolicyUrl}
              style={{ color: '#007aff' }}
            >
              台北市公有條款
            </a>
          </div>
          <Button
            className="w-full my-4"
            onClick={() => {
              navigate(
                {
                  pathname: `/${PATHS.USER}`,
                },
                { merge: true },
              );
            }}
          >
            開始
          </Button>
          <div className="text-gray-400">本服務由 Autopass 提供</div>
        </div>
      </div>
    </div>
  );
}
